jQuery_T4NT(document).ready(function($) {
// hide FBT list when current option is dupatta or pants 
document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
    ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});
  function reloadTabContent(tabId,vid) {
    fetch(location.href+vid)
      .then(response => response.text())
      .then(data => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var tabContent = doc.getElementById(tabId);
        var currentTabContent = document.getElementById(tabId);
        if (tabContent && currentTabContent) {
          currentTabContent.innerHTML = tabContent.innerHTML;
        }
      })
      .catch(error => console.error('Error:', error));
  }
$( document ).on( "variant:changed", function( evt ) {
  
  reloadTabContent('tab-22', `?variant=${evt.currentVariant.id}`)
  if (evt.currentVariant.title.includes('Customized')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  // console.log(evt)
    const fbtTitle = evt.target.querySelector('.sr4-fbt__title');
    const fbtList = evt.target.querySelector('.sr4-fbt__swatches');
    const fbtInput = evt.target.querySelectorAll('.sr4-fbt__swatches #addon_list_input')
    const fbtInputQty = evt.target.querySelectorAll('.sr4-fbt__swatches #addon_list_input_qty')
  if(evt.currentVariant.title.toLowerCase().includes('dupatta')
     || evt.currentVariant.title.toLowerCase().includes('pants') 
     || evt.currentVariant.title.toLowerCase().includes('lehnga')
     || evt.currentVariant.title.toLowerCase().includes('culottes')
     || evt.currentVariant.title.toLowerCase().includes('shawl')
     || evt.currentVariant.title.toLowerCase().includes('palazzo')
     || evt.currentVariant.title.toLowerCase().includes('saree')
     || evt.currentVariant.title.toLowerCase().includes('izzar')
     || evt.currentVariant.title.toLowerCase().includes('gharara')) {
      if (fbtTitle && fbtList) {
        fbtTitle.style.display = 'none';
        fbtList.style.display = 'none';
        fbtInput.forEach((ele)=>{
          ele.disabled = true;
        });
        fbtInputQty.forEach((ele)=>{
          ele.disabled = true;
        });
      }
  } else{
      if (fbtTitle && fbtList) {
        fbtTitle.style.display = 'block';
        fbtList.style.display = 'block';
      }
  }

  const productPrice = evt.target.querySelector('.sr4-product-price');
  const productAtc = evt.target.querySelector('.disable_form_class');
  const productFBT = evt.target.querySelector('.sr4-fbt__wrap');
  if (evt.currentVariant.title.toLowerCase().includes('heirloom shawl')) {
      // productPrice.innerHTML = `<a href="https://api.whatsapp.com/send?phone=923000255595&amp;text=Interested in ${productPrice.dataset.producturl}" target="_blank" aria-describedby="a11y-new-window-external-message" rel="noopener">Inquire on whatsapp</a>`
      if (!productFBT) {
          if (productAtc) {
              productAtc.setAttribute('style', 'display: none !important');
          }
      } else {
          productFBT.setAttribute('style', 'display: none !important');
      }

  } else {
      if (!productFBT) {
          if (productAtc) {
              productAtc.setAttribute('style', 'display: block !important');
          } 
      } else {
          productFBT.setAttribute('style', 'display: block !important');
      }
  }
  const fbtPPS = evt.target.querySelector(`#parentProduct select option[data-variantcon="${evt.currentVariant.title}"]`);
    if (fbtPPS) {
      fbtPPS.selected = true;
    }  
})
    

});